/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react'
import styles from "./styles.module.scss"
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import Curve from './Curve';
import { Step, StepLabel, Stepper } from '@mui/material';
import { styled } from '@mui/material/styles';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { IMAGE_URL_v4 } from '../../../../envs/prod/constants';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 6,
        left: 'calc(-50% + 8px)',
        right: 'calc(50% + 8px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: 'white',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: 'white',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : 'white',
        borderTopWidth: 10,
        borderRadius: 1,
    },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : 'white',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
        color: 'black',
        background: 'white',
        width: '117px',
        display: 'flex',
        justifyContent: 'center',
        height: '46px',
        marginTop: -12,
        borderRadius: 40,
        textAlign: 'center',
    }),
    '& .QontoStepIcon-completedIcon': {
        color: 'black',
        zIndex: 1,
        fontSize: 20,
        fontFamily: 'Inter',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        letterSpacing: '-0.9px',
    },
    '& .QontoStepIcon-circle': {
        width: 30,
        height: 30,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
}));

export default function TeamTimelineSection({ windowSize }) {
    const [activeState, setActiveState ] = useState(0);
    const dataItems = [{
        id: 1,
        title: 'Started from a rock',
        date: 'Jan 2021',
        description: 'Seekho started with a mission to redefine edutainment for Bharat',
        image: `${IMAGE_URL_v4}/teamspage/startfromrock.webp`,
        color: "#98DD77",
        d_color: '#267800',
        bg: 'assets/teams/curve1.svg',
    },
    {
        id: 2,
        title: 'Launched the app',
        date: 'Jun 2021',
        description: 'We launched the first version of app on Playstore with educational series in Hindi',
        image: `${IMAGE_URL_v4}/teamspage/launch.webp`,
        color: "#EDCD5D",
        d_color: '#866900',
        bg: 'assets/teams/curve2.svg',

    }, {
        id: 3,
        title: 'Moved to Bangalore',
        date: 'Nov 2022',
        description: 'We flew to Bangalore to take up better challenges and experience unparalleled growth',
        image: `${IMAGE_URL_v4}/teamspage/movedtobang.webp`,
        color: "#FFB5E6",
        d_color: '#D22E9A',
        bg: 'assets/teams/curve3.svg',

    }, {
        id: 4,
        title: 'Got funded',
        date: 'Feb 2023',
        description: 'Elevation Capital believed in our vision and decided to walk the journey together',
        image: `${IMAGE_URL_v4}/teamspage/gotfund.webp`,
        color: "#FFB9B9",
        d_color: '#E64A4A',
        bg: 'assets/teams/curve4.svg',
    }, {
        id: 5,
        title: 'Walked into our new office',
        date: 'Jun 2023',
        description: 'More smiles, sweeter coffees and tighter deadlines  paving way for an exciting journey ahead',
        image: `${IMAGE_URL_v4}/teamspage/newoffice.webp`,
        color: "#A9DBE1",
        d_color: '#0E7C89',
        bg: 'assets/teams/curve5.svg',
    }, {
        id: 6,
        title: 'Doubled in fam!',
        date: 'Jun 2023',
        description: '5 crazy amazing folks joined us to make Seekho even stronger',
        image: `${IMAGE_URL_v4}/teamspage/joined.webp`,
        color: "#C2D7FF",
        d_color: '#2A57AB',
        bg: 'assets/teams/curve6.svg',
    }];
    const steps = ['Jan 2021', 'Jun 2021', 'Nov 2022', 'Feb 2023', 'Jun 2023', 'Jun 2023'];
    function QontoStepIcon(props) {
        const { active, completed, className } = props;
        return (
            <QontoStepIconRoot ownerState={{ active }} className={className}>
                {active ? (
                    <span className="QontoStepIcon-completedIcon">{steps[activeState]}</span>
                ) : (
                    <div className="QontoStepIcon-circle" />
                )}
            </QontoStepIconRoot>
        );
    }

    const handleStep = (step) => () => {
        setActiveState(step);
        const swiper = document?.querySelector('.mySwipers_timeline').swiper;
        swiper.slideTo(step);
    };

    const changeActive = (current) => {
        setActiveState(current?.realIndex)
    }

    return (
        <div className={styles.teams_timeline_wrapper}>
            {windowSize >= 768 ? <Swiper
                loop={true}
                pagination={{
                    clickable: false,
                }}
                onSlideChange={(data) => changeActive(data)}
                className="mySwipers_timeline"
                style={{ height: "1000px" }}
            >
                {dataItems?.map((item, index) => (
                    <SwiperSlide className={styles.swiper_slide} key={index} >
                        <img alt="seekho" src={item.bg} className={styles.swiperimg} style={{ marginTop: index === 1 ? 12 : index === 2 ? 53 :  index === 3 ? 13 :  index === 4 ? 53 : index === 5 && 12 }}/>
                        <div className={styles.desk_swiper_slide_data_set}>
                            <div className={styles.swiper_slide_header}>
                                <p className={styles.swiper_slide_header_title}>OUR STORY</p>
                                <p className={styles.swiper_slide_header_content}>Been a wonderful journey</p>
                            </div>
                            <Stepper alternativeLabel className={styles.custom_stepper} style={{width: "80%", margin: "50px auto"}} activeStep={activeState} connector={<QontoConnector />}>
                                {steps.map((label, index) => (
                                    <Step key={index}>
                                        <StepLabel onClick={handleStep(index)} label={label} StepIconComponent={QontoStepIcon} style={{ cursor: 'pointer'}}></StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                            <div className={styles.stepdata}>
                                <div className={styles.swiper_slide_data}>
                                    <div className={styles.swiper_slide_data_title}>{item.title}</div>
                                    <div className={styles.swiper_slide_data_description}>{item.description}</div>
                                </div>
                                <div className={styles.swiper_slide_data_image}>
                                    <img alt="seekho" src={item.image} />
                                </div>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            :
            <Swiper
                loop={true}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                className="mySwipers_timeline"
                style={{ height: "80%" }}
            >
                {dataItems?.map((item, index) => (
                    <SwiperSlide className={styles.swiper_slide} key={index}  >
                        <Curve fill={item.color} windowSize={windowSize} />
                            <div className={styles.swiper_slide_data_set}>
                                <div className={styles.swiper_slide_data}>
                                    <div className={styles.swiper_slide_data_date} style={{ color: item.d_color }}>{item.date}</div>
                                    <div className={styles.swiper_slide_data_title}>{item.title}</div>
                                    <div className={styles.swiper_slide_data_description}>{item.description}</div>
                                </div>
                                <div className={styles.swiper_slide_data_image}>
                                    <img alt="seekho" src={item.image} />
                                </div>
                            </div>
                    </SwiperSlide>
                ))}
            </Swiper>}
        </div>
    )
}
